import { Input } from 'antd';
import styled from 'styled-components';
import { sharedInputStyles } from '../../styled';

export const StyledInput = styled(Input)`
    ${sharedInputStyles};
`;
